import { action } from 'satcheljs/lib/legacy';
import MeetingRequestMessageType from 'owa-service/lib/contract/MeetingRequestMessageType';
import ResponseTypeType from 'owa-service/lib/contract/ResponseTypeType';
import respondToMeetingMessageService from '../services/respondToMeetingMessage';
import {
    instantCalendarEventUpdate,
    instantCalendarEventDelete,
    getCalendarEventUpdatesForResponseTypeChange,
} from 'owa-calendar-events-store';
import { ClientItemId } from 'owa-client-ids';
import { wrapInCalendarEventOperationResult } from './wrapInCalendarEventOperationResult';
import { getEventScope } from './getEventScope';
import { getCalendarEventWithId } from 'owa-calendar-events-store';
import { isFeatureEnabled } from 'owa-feature-flags';
import { ViewType } from 'owa-calendar-actions';

export default action('respondToMeetingRequest')(async function respondToMeeting(
    message: MeetingRequestMessageType,
    response: ResponseTypeType,
    sendResponse: boolean,
    actionSource: ViewType,
    responseMessage?: string
): Promise<void> {
    if (!message.AssociatedCalendarItemId) {
        respondToMeetingMessageService(message, response, sendResponse, responseMessage);
        return;
    }

    if (response == 'Decline' && !isFeatureEnabled('cal-surface-declinedMeetings')) {
        instantCalendarEventDelete(
            message.AssociatedCalendarItemId as ClientItemId,
            getEventScope(message) /** eventScope */,
            null,
            () =>
                wrapInCalendarEventOperationResult(() =>
                    respondToMeetingMessageService(message, response, sendResponse, responseMessage)
                ) /** actionToExecute */,
            () => {} /** onEventDeleteSuccess */,
            () => {} /** onEventDeleteFailed */,
            actionSource /** actionSource */
        );
    } else {
        const event = getCalendarEventWithId(message.AssociatedCalendarItemId.Id);
        if (event) {
            const calendarItemChanges = getCalendarEventUpdatesForResponseTypeChange(
                event.FreeBusyType,
                event.ResponseType,
                response
            );
            instantCalendarEventUpdate(
                message.AssociatedCalendarItemId as ClientItemId,
                calendarItemChanges,
                getEventScope(message) /** eventScope */,
                () =>
                    wrapInCalendarEventOperationResult(() =>
                        respondToMeetingMessageService(
                            message,
                            response,
                            sendResponse,
                            responseMessage
                        )
                    ) /** actionToExecute */,
                () => {} /** onEventDeleteSuccess */,
                () => {} /** onEventDeleteFailed */,
                actionSource /** actionSource */
            );
        } else {
            respondToMeetingMessageService(message, response, sendResponse, responseMessage);
        }
    }
});
